import React from "react";
import DateCard from "./DateCard";
import { CousrsDetailsType } from "@/app/types";
import { useTranslations } from "next-intl";

const AvailableClassCard = ({ course }: DatesCardsPropsType) => {
  const t = useTranslations("courses.dates.available");

  return (
    <DateCard
      color={course?.color}
      dates={course?.dateSlots?.filter((date) => date.type == "Group")}
      name={t("title")}
      numberOfStudents={t("info")}
      studentsInClass={t("subInfo")}
      price={120}
    />
  );
};
export default AvailableClassCard;
type DatesCardsPropsType = {
  course: CousrsDetailsType;
};
